import styled from "styled-components";

const UsersContainer = styled.div``;


export { UsersContainer };
